module.exports = __webpack_public_path__ + "static/media/qr-code.a6d6168b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/qr-code.png
// module id = 617
// module chunks = 0